import { createSlice } from '@reduxjs/toolkit';

function getClientDate() {
    let startDate = localStorage.getItem("startDate");
    let oneMonthAgo = new Date(new Date().getFullYear(), new Date().getMonth() - 1, new Date().getDate())

    if (startDate) {
        let storedDate = new Date(new Date(startDate).getTime() - 330 * 60000);

        if (storedDate > oneMonthAgo) {
            return storedDate;
        } else {
            return oneMonthAgo;
        }
    } else {
        return oneMonthAgo;
    }
}

const initialState = {
    startDate: getClientDate() || new Date(new Date().getFullYear(), new Date().getMonth() - 1, new Date().getDate()),
    endDate: new Date(new Date().setDate(new Date().getDate() - 1)),
    storeNumbers: 'all',
    storeName: [],
    mirrorIds: [],
    platform: null
};

const dateRangeSlice = createSlice({
    name: 'dateRange',
    initialState,
    reducers: {
        setDateRangeInner: (state, action) => {
            state.startDate = action.payload.startDate;
            state.endDate = action.payload.endDate;
        },
        setPlatform: (state, action) => {
            const platform = action.payload.platform || "";
            state.platform = platform;
            if (platform === "MIRROR") {
                state.storeName = action.payload.storeName ?? [];
                state.mirrorIds = action.payload.mirrorIds ?? [];
            } else {
                state.storeName = [];
                state.mirrorIds = [];
            }
        },
        setStoreMirror: (state, action) => {
            state.storeName = action.payload.storeName || state.storeName;
            state.mirrorIds = action.payload.mirrorIds || state.mirrorIds;
        }
    }
});

export const { setDateRangeInner, setPlatform, setStoreMirror } = dateRangeSlice.actions;
export default dateRangeSlice.reducer;